import { FormActions } from "../../components/common/FormActions";
import { TTableColumn } from "../../types/common";
import { createViewEdit, numberFormat } from "../../utils/helpers";
import moment from "moment";

export const useInstalment = ({
  isRestructured = false,
  total_amount_payable = 0,
}) => {
  const tableColumns = (): TTableColumn[] => [
    { id: "due_date", header: "Due Date" },
    { id: "remaining", header: "Time remaining" },
    { id: "beginning_balance", header: "Beginning Balance" },
    { id: "ending_balance", header: "Ending Balance" },
    { id: "interest", header: "Interest" },
    { id: "principal", header: "Principle" },
    { id: "amount", header: "Amount" },
    { id: "amount_paid", header: "Amount Paid" },
    { id: "open_balance", header: "Open Balance" },
    { id: "outstanding", header: "Outstanding Balance" },
  ];
  const tableData = (data: any) => {
    const total_interest = data.reduce(
      (acc: number, item: any) => acc + item.interest,
      0,
    );
    let outstanding =
      data[0]?.amortization_method === "reducing-balance"
        ? data[0]?.beginning_balance + total_interest
        : data[0]?.total_loan_value;

    let open_balance = 0;
    return data.map((item: any) => {
      open_balance = open_balance + item?.amount - item?.amount_paid;
      return {
        ...item,
        remaining: moment(item?.due_date).fromNow(),
        amount: numberFormat(item?.amount),
        beginning_balance: numberFormat(item?.beginning_balance),
        ending_balance: numberFormat(item?.ending_balance),
        interest: numberFormat(item?.interest),
        principal: numberFormat(item?.principal),
        amount_paid: numberFormat(item?.amount_paid),
        outstanding: numberFormat((outstanding -= item?.amount_paid)),
        open_balance: numberFormat(open_balance),
        actions: (
          <FormActions
            actions={createViewEdit("/loan_application", item?.id)}
          />
        ),
      };
    });
  };
  const totalsData = (data: any) => {
    if (!Array.isArray(data)) {
      return {};
    }
    const totals = data || [];
    const first_item = totals[0] || {};
    let total_amount_paid = 0,
      total_interest = 0,
      total_amount = 0,
      total_principle = 0;
    totals.forEach((item: any) => {
      total_amount_paid += item?.amount_paid || 0;
      total_principle += item?.principal || 0;
      total_interest += item?.interest || 0;
      total_amount += item?.amount || 0;
    });
    return {
      name: `${first_item?.first_name || ""} ${first_item?.last_name || ""}`,
      number_plate: first_item?.number_plate || "",
      ...(isRestructured && {
        restructured_loan_value: numberFormat(
          first_item?.restructured_loan_value,
        ),
      }),
      total_principle: numberFormat(total_principle),
      total_interest: numberFormat(total_interest),
      ...(isRestructured && {
        down_payment: numberFormat(first_item?.deposit_paid),
        total_amount_payable: numberFormat(total_amount_payable),
      }),
      total_amount: numberFormat(total_amount),
      total_amount_paid: numberFormat(total_amount_paid),
      total_outstanding_balance: numberFormat(total_amount - total_amount_paid),
    };
  };

  const viewData = (item: any) => {
    return {
      sections: [
        {
          title: "Details",
          fields: {
            amount: item?.amount,
            beginning_balance: item?.beginning_balance,
            ending_balance: item?.ending_balance,
            interest: item?.interest,
            principal: item?.principal,
            amount_paid: item?.amount_paid,
          },
        },
      ],
    };
  };

  return { tableColumns, tableData, viewData, totalsData };
};
